module.exports = "/images/vendor/flag-icon-css/flags/4x3/bo.svg?4128202a176b10fa597f1221f8e7e4cd";